import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';

// Helyi (standalone, Keycloak nélküli) bejelentkezés. Csak akkor aktív, ha
// environment.standalone && environment.standaloneLogin. A /api/login által kiadott
// helyi tokent eltároljuk, és az interceptor küldi a backendnek.
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  username = '';
  password = '';
  hiba = '';
  folyamatban = false;

  // A legutóbb használt felhasználónevet megjegyezzük, hogy ne kelljen újra beírni.
  private static readonly LAST_USER_KEY = 'ny_last_username';

  constructor(private http: HttpClient, private router: Router, private auth: AuthService) {}

  ngOnInit() {
    // Ha nem standalone-login mód, vagy már van érvényes token, ne maradjunk itt.
    if (!this.auth.isStandaloneLogin() || this.auth.hasValidLocalToken()) {
      this.router.navigateByUrl('/home');
      return;
    }
    // Korábbi felhasználónév előtöltése.
    try {
      this.username = localStorage.getItem(LoginComponent.LAST_USER_KEY) || '';
    } catch { /* localStorage nem elérhető */ }
  }

  async belepes() {
    this.hiba = '';
    const username = this.username.trim().toLowerCase();
    const password = this.password;
    if (!username || !password) { this.hiba = 'Add meg a felhasználónevet és a jelszót.'; return; }
    this.folyamatban = true;
    try {
      const resp: any = await firstValueFrom(
        this.http.post('/api/login', { username, password }, { headers: { 'Skip-Auth': '1' } })
      );
      if (!resp?.token) throw new Error('Nincs token a válaszban.');
      this.auth.setLocalToken(resp.token);
      // Sikeres belépéskor megjegyezzük a felhasználónevet a következő alkalomra.
      try { localStorage.setItem(LoginComponent.LAST_USER_KEY, username); } catch { /* ignore */ }
      // Teljes újratöltés, hogy az app bootstrap (menü/jogkör) lefusson az új tokennel.
      window.location.href = window.location.origin + '/';
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Hibás felhasználónév vagy jelszó.';
      this.folyamatban = false;
    }
  }
}
